import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { CloseWindowButton } from '../../app-core/lib/ui/CloseWindowButton'

enum Events {
    onClick = 'on-click',
}

@customElement('zaptic-close-window-button')
export class CloseWindowButtonWrapper extends LitElement {
    onClick = () => {
        this.dispatchEvent(new CustomEvent(Events.onClick, { composed: true }))
    }

    render() {
        return ReactDOM.render(<CloseWindowButton onClick={this.onClick} />, this)
    }

    protected createRenderRoot() {
        return this
    }
}
